import { Radar } from "lucide-react";

export const InnovationTeaser = () => {
  return (
    <section
      data-testid="innovation-teaser"
      className="relative bg-[#040812] py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="relative bg-[#0B132B]/40 border border-white/10 red-glow overflow-hidden">
          <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-red-500/10 blur-3xl rounded-full pointer-events-none" />

          <div className="relative p-8 md:p-14 flex flex-col md:flex-row items-start md:items-center gap-8">
            <div className="flex items-center justify-center h-14 w-14 rounded-sm border border-red-500/30 bg-red-500/5 shrink-0">
              <Radar size={22} className="text-red-500" strokeWidth={1.5} />
            </div>
            <div className="flex-1">
              <div className="overline">Innovation Lab · Classified Roadmap</div>
              <h3 className="mt-4 font-display text-white text-2xl md:text-3xl lg:text-4xl tracking-tighter font-light leading-tight">
                Sriman Solutions Innovation Lab —{" "}
                <span className="text-slate-400">Coming Soon:</span>{" "}
                <span className="text-red-500">Sriman D Satellite Shield.</span>
              </h3>
              <p className="mt-5 text-slate-500 text-sm md:text-base max-w-2xl leading-relaxed">
                A next-generation defensive perimeter for high-stakes enterprise
                data. Further disclosures under NDA only.
              </p>
            </div>
            <div className="hidden md:flex flex-col items-end">
              <span className="font-mono text-[10px] text-slate-500 tracking-[0.28em] uppercase">
                Status
              </span>
              <span className="mt-2 inline-flex items-center gap-2 text-red-500 text-xs font-mono tracking-widest">
                <span className="h-2 w-2 bg-red-500 rounded-full animate-pulse" />
                IN DEVELOPMENT
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationTeaser;
